/* Horizon >= 990px: quem rola e o .page-wrapper (html/body overflow:hidden), nao o documento. Os scripts
   copiados do tema dele (linha do tempo mv-vj, botao "voltar ao topo") escutam window 'scroll', leem
   window.scrollY e chamam window.scrollTo: aqui o scroll do .page-wrapper vira evento de window e
   scrollY/pageYOffset/scrollTo usam o conteiner real. */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function pw() {
    if (!mq.matches) return null;
    var w = document.querySelector('.page-wrapper');
    if (!w) return null;
    var o = getComputedStyle(w).overflowY;
    // so quando ele e o conteiner que rola de fato (o kit/um app pode devolver a rolagem ao documento)
    return (o === 'auto' || o === 'scroll') && w.scrollHeight > w.clientHeight + 1 ? w : null;
  }
  ['scrollY', 'pageYOffset'].forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(window, k) || Object.getOwnPropertyDescriptor(Window.prototype, k);
    if (!d || !d.get) return;
    try {
      Object.defineProperty(window, k, { configurable: true, get: function () { var w = pw(); return w ? w.scrollTop : d.get.call(window); } });
    } catch (e) {}
  });
  var nativeTo = window.scrollTo.bind(window);
  window.scrollTo = function (a, b) {
    var w = pw();
    /* sem conteiner (mobile): repassa os MESMOS argumentos; nativeTo({top}, undefined) cai na forma (x, y)
       e rola para 0,0 (retrabalho 10-30: todo CTA 'rolar ate o buybox' ia para o topo no mobile) */
    if (!w) return arguments.length > 1 ? nativeTo(a, b) : nativeTo(a);
    if (typeof a === 'object') w.scrollTo(a); else w.scrollTo(a || 0, b || 0);
  };
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('page-wrapper')) window.dispatchEvent(new Event('scroll'));
  }, true);
  // CTAs "comprar" das secoes -> buybox (ancora #cl-buybox), rolagem suave no conteiner certo
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#cl-buybox"]');
    if (!a) return;
    var t = document.getElementById('cl-buybox');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
